import { render, staticRenderFns } from "./NavigationSidebar.vue?vue&type=template&id=edc7e7f4&"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
